import { render, staticRenderFns } from "./CustomizationManagement.vue?vue&type=template&id=47bc6b6c&"
import script from "./CustomizationManagement.vue?vue&type=script&lang=js&"
export * from "./CustomizationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports